import React from 'react';
import { Box } from '~/native-ui/native-base';
import { useThemeProps, usePropsResolution, } from 'native-base';
import { AccordionContext, AccordionItemContext } from './Context';
// import { useHasResponsiveProps } from '../../../hooks/useHasResponsiveProps';

const AccordionItem = (
  { children, index: pIndex = 0, isDisabled, ...props },
  ref
) => {
  const {
    index: cIndex,
    changeHandler,
    shouldOpen,
  } = React.useContext(AccordionContext);
  const isOpen = cIndex?.includes(pIndex);
  const { ...newProps } = useThemeProps('AccordionItem', props);

  const onClose = (cb) => {
    changeHandler && changeHandler(false, pIndex);
    cb && cb();
  };
  const onOpen = (cb) => {
    if(shouldOpen && !shouldOpen()) return;
    changeHandler && changeHandler(true, pIndex);
    cb && cb();
  };
  const childSetter = () => {
    if (typeof children === 'function')
      return children({ isExpanded: isOpen, isDisabled });
    return children;
  };
  //TODO: refactor for responsive prop
  // if (useHasResponsiveProps(props)) {
  //   return null;
  // }
  return (
    <AccordionItemContext.Provider
      value={{
        index: pIndex,
        isOpen,
        isDisabled,
        onClose,
        onOpen,
      }}
    >
      <Box {...newProps} ref={ref}>
        {childSetter()}
      </Box>
    </AccordionItemContext.Provider>
  );
};

export default React.memo(React.forwardRef(AccordionItem));
